var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-screen-btn-con"},[_c('Tooltip',{attrs:{"content":"购物车","placement":"bottom"}},[_c('Icon',{attrs:{"type":"ios-cart-outline","size":23},nativeOn:{"click":function($event){_vm.showMethod(true)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }